import { DEVICE_TYPES, type DEVICE_TYPE } from '../constants/device'

const getUserDevice = (): DEVICE_TYPE => {
  const width = window.screen.width
  let screenType
  if (width <= 520) {
    screenType = DEVICE_TYPES.MOBILE
  } else if (width <= 820) {
    screenType = DEVICE_TYPES.TABLET
  } else {
    screenType = DEVICE_TYPES.DESKTOP
  }
  return screenType
}

export default getUserDevice
